const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  groupName: state => state.user.groupName,
  groupIconUrl: state => state.user.groupIconUrl,
  groupId: state => state.user.groupId,
  name: state => state.user.name,
  changePassword: state => state.user.changePassword,
  introduction: state => state.user.introduction,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  tips: state => state.tips,
  groupConfig: state => state.permission.groupConfig,
};
export default getters;
